import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { retryRead } from "./services/queries";

export const getRouter = () => {
  // gcTime 0: a query nobody is showing is dropped at once, so a page you return to shows Loading, never earlier data.
  // retryRead: TanStack's three retries, except for a session that is not found, which cannot come back.
  const queryClient = new QueryClient({ defaultOptions: { queries: { gcTime: 0, retry: retryRead } } });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
